import { render, staticRenderFns } from "./CommentComponent.vue?vue&type=template&id=a48cf75a"
import script from "./CommentComponent.vue?vue&type=script&lang=js"
export * from "./CommentComponent.vue?vue&type=script&lang=js"
import style0 from "./CommentComponent.vue?vue&type=style&index=0&id=a48cf75a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports